/**
 * @generated SignedSource<<5cafff1838997b43adcc22c10a2d95b6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecentlyViewedItemsHeart_viewer$data = {
  readonly portfolioItemMatches?: ReadonlyArray<{
    readonly item: {
      readonly serviceId: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"Heart_heartPortfolioItems">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"Heart_viewer">;
  readonly " $fragmentType": "RecentlyViewedItemsHeart_viewer";
};
export type RecentlyViewedItemsHeart_viewer$key = {
  readonly " $data"?: RecentlyViewedItemsHeart_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecentlyViewedItemsHeart_viewer">;
};

import RecentlyViewedItemsHeartViewerRefetchQuery_graphql from './RecentlyViewedItemsHeartViewerRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "loadPortfolioData"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "selectedItemIds"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "userIds"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": RecentlyViewedItemsHeartViewerRefetchQuery_graphql
    }
  },
  "name": "RecentlyViewedItemsHeart_viewer",
  "selections": [
    {
      "condition": "loadPortfolioData",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemIds",
              "variableName": "selectedItemIds"
            },
            {
              "kind": "Literal",
              "name": "portfolioTypes",
              "value": [
                "HEART"
              ]
            },
            (v0/*:: as any*/)
          ],
          "concreteType": "PortfolioItemV2",
          "kind": "LinkedField",
          "name": "portfolioItemMatches",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Heart_heartPortfolioItems"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "loadPortfolioData"
        },
        (v0/*:: as any*/)
      ],
      "kind": "FragmentSpread",
      "name": "Heart_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "ab8fe3ea189016741650caaa925ac02d";

export default node;
